import { BaseError } from '.';

export class CommonError extends BaseError {}

export class UnknownError extends CommonError {}
export class UnimplementedError extends CommonError {}
